var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{attrs:{"align":"center"}},[_vm._v("Tarife")]),_c('TarifeTable'),_c('v-btn',{attrs:{"to":"/new-tarif/","block":"","color":"primary"}},[_vm._v("Neuer Tarif")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }